import { render, staticRenderFns } from "./AlbumSongsModal.vue?vue&type=template&id=9cb8821a&scoped=true"
import script from "./AlbumSongsModal.vue?vue&type=script&lang=js"
export * from "./AlbumSongsModal.vue?vue&type=script&lang=js"
import style0 from "./AlbumSongsModal.vue?vue&type=style&index=0&id=9cb8821a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb8821a",
  null
  
)

export default component.exports